import { LiveTranslateService } from '../../services/live-translate.service';
import { CommonModule, formatDate } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, ElementRef, SimpleChanges } from '@angular/core';
import { Months } from '../../constants/months';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, NgModel } from '@angular/forms';


@Component({
  selector: 'range-year-month-picker',
  standalone:true,
  imports:[TranslateModule,CommonModule,FormsModule],
  templateUrl: './range-year-month-picker.component.html',
  styleUrls: ['./range-year-month-picker.component.scss']
})
export class RangeYearMonthPickerComponent implements OnInit {

  @Input() classDate?: string;
  @Input() minValue: Date = new Date(new Date().getFullYear() - 3, new Date().getMonth() + 1, 1)
  @Input() maxValue: Date = new Date(new Date().getFullYear() + 1, new Date().getMonth() + 1, 1)
  @Input() defaultValue: Date = new Date()
  @Output() onDateChange: EventEmitter<{ from: Date, to: Date }> = new EventEmitter<any>();
  readonly months = Months;
  togglePicker: boolean = false;
  selectedDate: string = '';
  yearRange: {
    from: {
      month: any,
      year: number,
      date: string
    },
    to: {
      month: any,
      year: number,
      date: string
    }
  } = {
      from: {
        month: this.defaultValue.getMonth() + 1,
        year: new Date().getFullYear(),
        date: ''
      },
      to: {
        month: this.defaultValue.getMonth() + 1,
        year: new Date().getFullYear(),
        date: ''
      }
    }

  @HostListener('document:click', ['$event.target'])
  public onPageClick(targetElement: any) {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.selectedDate = `${this.yearRange.from.date} - ${this.yearRange.to.date}`
      this.togglePicker = false;
    }
  }

  themeColor: any = ''

  constructor( public elementRef: ElementRef, public liveTranslate: LiveTranslateService) { }

  ngOnInit(): void {

    this.yearRange = {
      from: {
        date: formatDate(this.defaultValue, 'MM/yyyy', 'en'),
        month: this.defaultValue.getMonth() + 1,
        year: this.defaultValue.getFullYear()
      },
      to: {
        date: formatDate(this.defaultValue, 'MM/yyyy', 'en'),
        month: this.defaultValue.getMonth() + 1,
        year: this.defaultValue.getFullYear()
      }
    }
    this.selectedDate = `${this.yearRange.from.date} - ${this.yearRange.to.date}`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.yearRange = {
      from: {
        date: formatDate(this.defaultValue, 'MM/yyyy', 'en'),
        month: this.defaultValue.getMonth() + 1,
        year: this.defaultValue.getFullYear()
      },
      to: {
        date: formatDate(this.defaultValue, 'MM/yyyy', 'en'),
        month: this.defaultValue.getMonth() + 1,
        year: this.defaultValue.getFullYear()
      }
    }
    this.selectedDate = `${this.yearRange.from.date} - ${this.yearRange.to.date}`;

  }

  selectMonth(month: any, type: 'from' | 'to') {
    if (type == 'from') {
      if (month < this.minValue.getMonth()) return
      this.yearRange.from.month = month;
      this.yearRange.from.date = formatDate(new Date(this.yearRange.from.year, month - 1), 'MM/yyyy', 'en');
      this.selectedDate = `${this.yearRange.from.date} - `
      return
    }
    if (this.yearRange.to.year <= this.yearRange.from.year && month < this.yearRange.from.month) return
    this.yearRange.to.month = month;
    this.yearRange.to.date = formatDate(new Date(this.yearRange.to.year, month - 1), 'MM/yyyy', 'en');

    this.selectedDate = `${this.yearRange.from.date} - ${this.yearRange.to.date}`
    const from = new Date(this.yearRange.from.year, this.yearRange.from.month - 1)
    const to = new Date(this.yearRange.to.year, this.yearRange.to.month - 1)
    this.onDateChange.emit({ from, to })
    this.togglePicker = false

  }

  decrementYear(type: 'from' | 'to') {
    if (type == 'from') {
      if (this.yearRange.from.year < this.minValue.getFullYear()) return
      this.yearRange.from.year = this.yearRange.from.year - 1;
      this.yearRange.from.date = formatDate(new Date(this.yearRange.from.year, this.yearRange.from.month - 1), 'MM/yyyy', 'en');
    } else {
      if (this.yearRange.to.year < this.yearRange.from.year) return
      this.yearRange.to.year = this.yearRange.to.year - 1;
      this.yearRange.to.date = formatDate(new Date(this.yearRange.to.year, this.yearRange.to.month - 1), 'MM/yyyy', 'en');
    }
  }
  incrementYear(type: 'from' | 'to') {
    if (type == 'from') {
      if (this.yearRange.from.year >= this.maxValue.getFullYear()) return
      this.yearRange.from.year = this.yearRange.from.year + 1;
      this.yearRange.from.date = formatDate(new Date(this.yearRange.from.year, this.yearRange.from.month - 1), 'MM/yyyy', 'en');
    } else {
      if (this.yearRange.to.year >= this.maxValue.getFullYear()) return
      this.yearRange.to.year = this.yearRange.to.year + 1;
      this.yearRange.to.date = formatDate(new Date(this.yearRange.to.year, this.yearRange.to.month - 1), 'MM/yyyy', 'en');
    }
  }

  selectedDateChanged(event: string, inp: any) {
    this.selectedDate = `${this.yearRange.from.date} - ${this.yearRange.to.date}`;
    inp.value = this.selectedDate
    return


  }

  shadeSelectedFromDate(month: any) {
    return this.yearRange.from.month < month.id ? this.themeColor : ''
  }

  shadeSelectedToDate(month: any) {
    return this.yearRange.to.month > month.id ? this.themeColor : ''
  }
}
